"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OldPreview = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _date = require("../../../utils/date");
var SearchIcon = function SearchIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.5 20.5l-6-6m2-4.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
  }));
};
SearchIcon.defaultProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "#17181A"
};
var MoonIcon = function MoonIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.077 4.138l.49-.103a.5.5 0 0 0-.973-.027l.483.13zM5.862.922l.13.483a.5.5 0 0 0-.027-.972l-.103.49zM8.667 5A3.667 3.667 0 0 1 5 8.666v1A4.667 4.667 0 0 0 9.667 5h-1zm-.079-.76c.051.245.079.499.079.76h1c0-.33-.035-.654-.1-.965l-.979.206zm.006-.232a2.125 2.125 0 0 1-2.05 1.572v1c1.444 0 2.66-.981 3.016-2.313l-.966-.259zM6.544 5.58A2.123 2.123 0 0 1 4.42 3.456h-1A3.123 3.123 0 0 0 6.543 6.58v-1zM4.42 3.456c0-.98.666-1.808 1.571-2.05L5.733.438A3.125 3.125 0 0 0 3.42 3.456h1zM5 1.333c.26 0 .515.027.76.079l.205-.979A4.684 4.684 0 0 0 5 .333v1zM1.333 5A3.667 3.667 0 0 1 5 1.333v-1A4.667 4.667 0 0 0 .333 5h1zM5 8.666A3.667 3.667 0 0 1 1.333 5h-1A4.667 4.667 0 0 0 5 9.666v-1z",
    fill: "#4D4D4D"
  }));
};
MoonIcon.defaultProps = {
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var TouristsIcon = function TouristsIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8 3q0 1.25-.875 2.125T5 6t-2.125-.875T2 3q0-1.219.875-2.094Q3.75 0 5 0t2.125.906Q8 1.781 8 3zm18 0q0 1.25-.875 2.125T23 6t-2.125-.875T20 3q0-1.219.875-2.094Q21.75 0 23 0t2.125.906Q26 1.781 26 3zM8 8H2q-.844 0-1.406.594Q0 9.188 0 10v10h2v12h2.5V20h1v12H8V20h2V10q0-.813-.563-1.406Q8.843 8 7.999 8zm22.469 8L32 14.906l-4.156-6.438q-.156-.219-.375-.344T27 7.999h-8q-.25 0-.469.125t-.375.344L14 14.906 15.531 16 19 11.531l1.188 2.781L16 22h3.844l.656 10h2V22h1v10h2l.656-10H30l-4.188-7.688L27 11.531z"
  }));
};
TouristsIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
};
var DEFAULT_DEST_TEXT = 'Страна, город или отель';
var OldPreview = exports.OldPreview = function OldPreview(_ref) {
  var className = _ref.className,
    destination = _ref.destination,
    tourists = _ref.tourists,
    isMobile = _ref.isMobile,
    startDate = _ref.startDate,
    nights = _ref.nights,
    onOpenModal = _ref.onOpenModal;
  return /*#__PURE__*/_react["default"].createElement(StyledSearchWidgetPreview, {
    onClick: onOpenModal,
    isMobile: isMobile,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(PreviewItem, null, !isMobile && /*#__PURE__*/_react["default"].createElement(StyledSearchIcon, null), destination ? /*#__PURE__*/_react["default"].createElement(StyledDestination, null, destination) : DEFAULT_DEST_TEXT), destination && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(PreviewItem, null, startDate && /*#__PURE__*/_react["default"].createElement(StyledStartDate, null, (0, _date.formatDate)(startDate, 'dd MMM'))), /*#__PURE__*/_react["default"].createElement(PreviewItem, null, /*#__PURE__*/_react["default"].createElement(StyledMoonIcon, null), /*#__PURE__*/_react["default"].createElement(StyledNights, null, nights)), /*#__PURE__*/_react["default"].createElement(PreviewItem, null, /*#__PURE__*/_react["default"].createElement(StyledTouristsIcon, null), /*#__PURE__*/_react["default"].createElement("span", null, tourists))));
};
var PreviewItem = _styledComponents["default"].li.withConfig({
  displayName: "OldPreview__PreviewItem",
  componentId: "sc-5vckj7-0"
})(["display:flex;align-items:center;& + &::before{white-space:pre;content:'  \u2013  ';}"]);
var StyledDestination = _styledComponents["default"].span.withConfig({
  displayName: "OldPreview__StyledDestination",
  componentId: "sc-5vckj7-1"
})(["max-width:80px;text-overflow:ellipsis;overflow:hidden;display:inline-block;white-space:nowrap;"]);
var StyledSearchWidgetPreview = _styledComponents["default"].ul.withConfig({
  displayName: "OldPreview__StyledSearchWidgetPreview",
  componentId: "sc-5vckj7-2"
})(["display:flex;cursor:pointer;width:345px;height:30px;background-color:#fff3;border-radius:2px;color:rgba(255,255,255,0.6);font-size:13px;line-height:15px;padding:0 5px;", ""], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && "\n    flex-wrap: wrap;\n    font-size: 16px;\n    width: auto;\n    height: 45px;\n    min-width: 200px;\n    justify-content: center;\n    border-radius: 2.5px;\n    padding: 0 3px 3px;\n    background-color: transparent;\n    border: 1px solid #EFEFEF;\n\n    ".concat(PreviewItem, ":first-child {\n      width: 100%;\n\n      & + ").concat(PreviewItem, ":before {\n        content: '';\n      }\n\n      ").concat(StyledDestination, " {\n        max-width: unset;\n        margin: auto;\n      }\n    }\n  ");
});
var StyledSearchIcon = (0, _styledComponents["default"])(SearchIcon).withConfig({
  displayName: "OldPreview__StyledSearchIcon",
  componentId: "sc-5vckj7-3"
})(["width:10px;height:10px;stroke:#fff9;margin-right:5px;"]);
var StyledMoonIcon = (0, _styledComponents["default"])(MoonIcon).withConfig({
  displayName: "OldPreview__StyledMoonIcon",
  componentId: "sc-5vckj7-4"
})(["width:10px;height:10px;margin-right:5px;path{fill:#fff9;}"]);
var StyledTouristsIcon = (0, _styledComponents["default"])(TouristsIcon).withConfig({
  displayName: "OldPreview__StyledTouristsIcon",
  componentId: "sc-5vckj7-5"
})(["width:10px;height:10px;fill:#fff9;margin-right:5px;"]);
var StyledStartDate = _styledComponents["default"].span.withConfig({
  displayName: "OldPreview__StyledStartDate",
  componentId: "sc-5vckj7-6"
})([""]);
var StyledNights = _styledComponents["default"].span.withConfig({
  displayName: "OldPreview__StyledNights",
  componentId: "sc-5vckj7-7"
})([""]);